import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppInitializationGuard } from '@evorait/pace-core';
import { MainComponent } from './main/main.component';
import { ProtocolProvisioningComponent } from './protocol-provisioning/protocol-provisioning.component';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                { path: '', redirectTo: 'protocol-provisioning', pathMatch: 'full' },
                {
                    path: '',
                    component: MainComponent,
                    canActivate: [AppInitializationGuard],
                    children: [
                        {
                            path: 'protocol-provisioning',
                            component: ProtocolProvisioningComponent,
                        },
                        {
                            path: 'main',
                            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                            loadChildren: () => import('./forms/forms.module').then((m) => m.FormsModule),
                        },
                        { path: '', redirectTo: '/protocol-provisioning', pathMatch: 'full' },
                    ],
                },
                { path: '**', redirectTo: '' },
            ],
            {
                initialNavigation: 'enabledNonBlocking',
                enableTracing: false,
                useHash: true,
            },
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
